export const SET_MENU_ANCHOR = 'pointrThemedNavbar.setMenuAnchor'
export const SET_USER_ACTIONS_MENU_ANCHOR = 'pointrThemedNavbar.set'
export const RESET = 'pointrThemedNavbar.reset'

export function setMenuAnchor(anchor: any) {
  return {
    type: SET_MENU_ANCHOR,
    payload: anchor
  } as const
}

export function setUserActionsMenuAnchor(anchor: any) {
  return {
    type: SET_USER_ACTIONS_MENU_ANCHOR,
    payload: anchor
  } as const
}

export function reset() {
  return {
    type: RESET
  } as const
}

export type PointrThemedNavbarAction = ReturnType<typeof setMenuAnchor | typeof setUserActionsMenuAnchor | typeof reset>
